import React from 'react';
import { Flex, Heading, Button } from 'rebass';
import Field from 'components/Field';
import ErrorMessage from 'components/ErrorMessage';
import RadioInput from 'components/RadioGroup/RadioInput';
import Label from 'components/Label';
import { ACTIVE } from 'constants/index';

interface InformationForRecruiterStepProps {
  submitting: boolean;
  submitErrors: any;
  setNextFormStepHandler: any;
  setPreviousFormStepHandler: any;
  values: any;
  status: string;
}

const InformationForRecruiterStep: React.FC<InformationForRecruiterStepProps> = (
  props
): JSX.Element => {
  const { submitting, submitErrors, setPreviousFormStepHandler, values, status } = props;
  return (
    <Flex flexDirection="column" alignItems="center" py={7}>
      {submitErrors && <ErrorMessage>{submitErrors.data.error.message}</ErrorMessage>}
      <Heading fontSize={['20px']} fontWeight={6} mb={5}>
        Is there anything else you would like to inform the recruiter?
      </Heading>
      <Field name="info" placeholder="Type here" inputType="textarea" />
      <Flex width="100%" flexDirection="column" css="max-width: 400px;">
        <Label htmlFor="currency">What is the placement fee for the recruiter?</Label>
        <Flex width="50%" justifyContent="space-between" mt={1} mb={2}>
          <RadioInput name="currency" value="USD" defaultValue={values.currency || 'CAD'} />
          <RadioInput name="currency" value="CAD" defaultValue={values.currency || 'CAD'} />
        </Flex>
      </Flex>
      <Flex width="100%" flexDirection="column" css="max-width: 400px;">
        <Label htmlFor="currency">Placement Fee</Label>
        <Flex width="50%" justifyContent="space-between" mt={1} mb={2}>
          <RadioInput
            name="compensationType"
            value="Percentage"
            defaultValue={values.compensationType || 'Sum'}
          />
          <RadioInput
            name="compensationType"
            value="Sum"
            defaultValue={values.compensationType || 'Sum'}
          />
        </Flex>
      </Flex>
      <Field
        name="compensation"
        placeholder={values.compensationType === 'Percentage' ? '1-30%' : '$6000'}
        inputType="number"
        required
        numberInputMin={values.compensationType === 'Percentage' ? 1 : undefined}
        numberInputMax={values.compensationType === 'Percentage' ? 30 : undefined}
      />
      <Flex width="100%" justifyContent="space-between" mt={2} css="max-width: 550px;">
        <Button variant="primary" onClick={setPreviousFormStepHandler}>
          Back
        </Button>
        <Button type="submit" variant={submitting ? 'disabled' : 'primary'} disabled={submitting}>
          {status === ACTIVE ? 'Save' : 'Preview'}
        </Button>
      </Flex>
    </Flex>
  );
};

export default InformationForRecruiterStep;
